import { msg } from '@lingui/core/macro';

export const SHARED_LOGIN_FORGOT_PASSWORD = msg`Forgot password?`;
export const SHARED_LOGIN_EMAIL_REQUIRE = msg`Email cannot be empty.`;
export const SHARED_LOGIN_PASSWORD_REQUIRED = msg`Password cannot be empty.`;
export const SHARED_LOGIN_EMAIL_VALID_ERROR = msg`Please enter a valid email address.`;
export const SHARED_LOGIN_INCORRECT = msg`Incorrect login or password`;
export const SHARED_LOGIN_LOCKED_USER_DESC = msg`Your account is locked.`;
export const SHARED_LOGIN_LOCKED_USER_DESC_LINK = msg`Contact your Administrator`;
